define(function(require) {
    var IpsModel = require('civicsBase/ipsModel');
    return IpsModel.extend({
        urlRoot: '/delegate/civics-api/api/cdr/common/relatedapplications/',
        url:function(){
            var url = this.urlRoot;
            if(this.id){
                url+=this.id;
            }
            //we need to pass the application type in the extended property for the extension to know which cdr to use for the config
            //adding in url only for deleting related record
            if(this.applicationType){
                url+='?applicationType={0}';
                url = url.format(this.applicationType);
            }
            return url;
        }
    });
});
